import { AccessoriesPageData } from 'src/modules/accessories/AccessoriesPageMapping.ts';
import { IsRecommended } from 'src/modules/common/utils/parseRecommended.ts';

type AccessoryItem = AccessoriesPageData['vssAccessories']['valveAccessories']['0'];
export const sortAccessoriesBy = (isRecommend: IsRecommended) => (
    a: AccessoryItem,
    b: AccessoryItem,
) => `${isRecommend(a.item.Label) ? 'a' : 'z'}${a.item.Label}`
    .localeCompare(`${isRecommend(b.item.Label) ? 'a' : 'z'}${b.item.Label}`);

export const sortAccessories = (
    a: AccessoryItem,
    b: AccessoryItem,
) => `${a.item.zOption?.raw.join('') === '1' ? 'a' : 'z'}${a.item.Label}`
    .localeCompare(`${b.item.zOption?.raw.join('') === '1' ? 'a' : 'z'}${b.item.Label}`);
